import React from "react";
import QuickLinks from '../../../quick-links/QuickLinks';

class StandardCard extends React.Component {
	constructor(props){
		super()
	}

   render() {
      return (
		<div className={"top-topics-card" + " " + this.props.topicsData.cardColour}>
		   <h3><a href={this.props.topicsData.URL}>{this.props.topicsData.heading}</a></h3>
		   <div className="image-container">
		     <a href={this.props.topicsData.URL}>
		     <div className="top-topics-image" aria-label={this.props.topicsData.imageAlt} style={{ backgroundImage: `url(${this.props.topicsData.imageURL})` }}><span>{this.props.topicsData.imageAlt}</span>
             <div className="top-topics-image-overlay"></div>
		     </div>
		                  </a>
		   </div>
		   <p>{this.props.topicsData.description}</p>
		   <QuickLinks QuickLinks={this.props.topicsData.quickLinks} />
		</div>  
    );
  }
}

export default StandardCard;
